/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import BookingCheckoutForm from "pages/Front/Booking/components/BookingCheckout/BookingCheckoutForm";
import GiftCardShoppingCart from "pages/Front/Booking/components/GiftCardPackage/GiftCardShoppingCart";
import {SELL_GIFTCARD_VOUCHERS} from "helpers/config";
import VoucherShoppingCart from "pages/Front/Booking/components/GiftCardPackage/VoucherShoppingCart";

interface BookingCheckoutProps extends RouteComponentProps {}

const BookingCheckout = (props: BookingCheckoutProps) => {
    return (
        <div className={"BookingCheckout w-full flex-col"}>
            <BookingCheckoutForm company={null}>
                {SELL_GIFTCARD_VOUCHERS ? <VoucherShoppingCart withCheckoutButton={false} /> : <GiftCardShoppingCart withCheckoutButton={false} />}
            </BookingCheckoutForm>
        </div>
    );
};

export default withRouter(BookingCheckout);
